<template>
    <div>
                 <base-header type="gradient-success" class="pb-6 pt-6 pt-md-2">

        </base-header> 
        <div class="card shadow">
            <b-container>
                            <div class="card-body">
                <div class="row">
                    <div>
                        <b-row>
                            <b-col >
                                <section class="container" id="appointment-table">
                                    <div class="appointment-table-header my-2 mb-4">
                                        <div class="card-title">
                                            <!-- <router-link :to="{ name: 'add-subscriber' }" v-if="can">
                                                {{ $t('message.add') }}

                                                <i class="fas fa-plus-circle edit-icon"></i>
                                            </router-link> -->
                                             <a @click="$router.go(-1)"><i class="fa fa-arrow-left" aria-hidden="true"></i></a>
                                            <!-- <button 
                                                type="button"    
                                                @click="hasHistory() 
                                                    ? $router.go(-1) 
                                                    : $router.push('/')" class="my-5 btn btn-outline-success">&laquo; 
                                                 {{$t('message.backtap')}}
                                            </button> -->
                                        </div>

                                    <!-- <div class="row">
                                        <div class="col-4 d-inline-block ml-1 mr-5 width-270">
                                            <b-input-group size="sm" class="mb-3">
                                                <b-form-input type="text" size="sm" class="p-2 h-100" :placeholder="$t('message.search') + '...'" v-model="searchTerm"/>
                                            </b-input-group>
                                        </div>
                                    </div> -->

                                    </div>
                                    <div class="row appointment-table-content">
                                        <div class="container-fluid">
                                            <template v-if="contact_assurances.length > 0">
                                                <div
                                                    v-for="(contact_assurance, key) in contact_assurances"
                                                    :key="key"
                                                    class="row appointment-item"
                                                >
                                                    <div class="col-lg-3">
                                                            <span class="appointment-label">
                                                                {{ $t('message.name') }}
                                                            </span>
                                                        <h4 class="appointment-date">{{ contact_assurance.nom }}</h4>
                                                    </div>
                                                    <div class="col-lg-3">
                                                        <span class="appointment-label">
                                                                {{ $t('message.email') }}
                                                            </span>
                                                        <h4 class="appointment-hour">{{ contact_assurance.email }}</h4>
                                                    </div>
                                                    <div class="col-lg-2">
                                                        <span class="appointment-label">
                                                            {{ $t('message.phoneNumber') }}
                                                        </span>
                                                        <h4>
                                                            {{ contact_assurance.telephone }}
                                                        </h4>
                                                    </div>
                                                    <div class="col-lg-2">
                                                        <span class="appointment-label">
                                                            {{ $t('message.nationality') }}
                                                        </span>
                                                        <h4>{{ contact_assurance.pays }}</h4>
                                                    </div>
                                                    <div class="col-lg-2">
                                                        <span class="appointment-label">
                                                            {{ $t('message.entreprise') }}
                                                        </span>
                                                        <h4>{{ contact_assurance.entreprise }}</h4>
                                                    </div>
                                                    <div class="col-lg-2">
                                                        <span class="appointment-label">
                                                            {{ $t('message.created_at') }}
                                                        </span>
                                                        <h4>{{ contact_assurance.created_at }}</h4>
                                                    </div>
                                                    <div class="col-lg-9">
                                                        <span class="appointment-label">
                                                            {{ $t('message.description') }}
                                                        </span>
                                                        <h4> {{ contact_assurance.description }} </h4>
                                                    </div>
                                                    <!-- <div class="col-lg-1">
                                                        {{ $t('message.action') }}
                                                        <b-button
                                                                variant="primary"
                                                                class="mb-2"
                                                                size="sm"
                                                                @click="viewAffiliation(contact_assurance.slug)"
                                                        >
                                                        {{ $t('message.show') }}
                                                        </b-button>
                                                        
                                                    </div> -->
                                                </div>
                                            </template>

                                            <template v-else>
                                                <h4>{{ $t('message.noItemToDisplay') }}</h4>
                                            </template>

                                        </div>
                                    </div>
                                    <div class="row appointment-table-footer">

                                    </div>
                                </section>
                            </b-col>
                        </b-row>
                    </div>
                </div>

            </div>
            </b-container>
        </div>
    </div>
</template>

<script>
    import { mapGetters } from 'vuex';
    import axios from 'axios';
    import moment from 'moment';
    import _ from 'lodash';
    import Swal from 'sweetalert2';
    import { pagination, handlePaginationClick } from "../../helpers/paginations";
    import AppConfig from '../../constants/AppConfig';
    export default {
        name: "ProspectAssurances",

        computed: {
            ...mapGetters(["affiliations",'hasAdminRole',
                'hasGestionnaireRole',
                'hasPraticienRole',
                'hasMedecinControleRole','hasAssistante'
            ]),

            can:function(){
                return this.hasAdminRole || this.hasGestionnaireRole || this.hasPraticienRole || this.hasMedecinControleRole || this.hasAssistante;
            },
        },

        data() {
            return {
                searchTerm : '',
                contact_assurances: []
            }
        },
        watch:{
        },
        methods: {
            hasHistory () { return window.history.length > 2 },

            viewAffiliation(slug){
                this.$router.push(  (this.$router.resolve({ name: 'affiliation',  params: { contrat: slug } })).href +  '#generale');
            }

      
        },

        mounted() {
            // Fetch subscriber list
            let sArray = [];
                axios.get(AppConfig.apiUrl+'/contact_assurances', {headers: {'Authorization': "Bearer " + localStorage.getItem('ms-token')}}).then(res => {
                    res.data.contact_assurances.forEach(contact_assurance => {
                        let contact = {};
                        contact.id = contact_assurance.id;
                        contact.nom = contact_assurance.nom.toUpperCase()+" "+contact_assurance.prenom.charAt(0).toUpperCase()+contact_assurance.prenom.substring(1);
                        contact.email = contact_assurance.email;
                        contact.telephone = contact_assurance.telephone;
                        contact.pays = contact_assurance.pays;
                        contact.entreprise = contact_assurance.entreprise;
                        contact.description = contact_assurance.description;
                        contact.created_at = moment(contact_assurance.created_at).format('DD-MM-YYYY');
                        sArray.push(contact);
                    });
                }).catch(error => {
                    console.log('error ', error);
                })
            this.contact_assurances = sArray; 
        }
    }
</script>

<style scoped>

</style>